/* 
Displays specific Transcoder info
*/
import { Stack, Text, Grid, Group, Pagination, Center, Tooltip } from "@mantine/core";
import { IconCurrencyEthereum } from "@tabler/icons";
import RegionToText from "../RegionInfo/RegionToText";
import PaymentBox from "../PaymentInfo/PaymentBox";
import { useState } from "react";

const itemsPerPage = 7;

export default function TranscoderInfo(props) {
  const [activePage, setPage] = useState(1);
  const thisInfo = props.transcoder;
  const thisPayments = props.paymentInfo;
  const maxItems = props.paymentInfo.length;
  const maxPages = Math.ceil(maxItems / itemsPerPage);
  return (
    <Stack spacing={24}>
      <Stack spacing={24}>
        <Stack spacing={24}>
          <Grid
            columns={6}
            sx={{
              borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
              borderRadius: "7px",
            }}
          >
            <Grid.Col span={3}>
              <Tooltip label={"Eth that will be payed out to the Transcoder once the minimum threshold has been reached"}>
                <Text>Pending</Text>
              </Tooltip>
            </Grid.Col>
            <Grid.Col span={3}>
              <Tooltip label={"Eth payed out to the Transcoder"}>
                <Text>Payout</Text>
              </Tooltip>
            </Grid.Col>
          </Grid>
        </Stack>
        <Stack spacing={0}>
          <Grid columns={6} sx={{ marginBottom: "12px" }}>
            <Grid.Col span={3}>
              <Group>
                <Text
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {thisInfo.vested.toFixed(8)}
                </Text>
                <IconCurrencyEthereum size={18} color={"#86c232"} />
              </Group>
            </Grid.Col>
            <Grid.Col span={3}>
              <Group>
                <Text
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {thisInfo.payout.toFixed(8)}
                </Text>
                <IconCurrencyEthereum size={18} color={"#86c232"} />
              </Group>
            </Grid.Col>
          </Grid>
        </Stack>
      </Stack>
      <Stack spacing={24}>
        <Stack spacing={24}>
          <Grid
            columns={9}
            sx={{
              borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
              borderRadius: "7px",
            }}
          >
            <Grid.Col span={3}>
              <Text>Region</Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text>Capacity</Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text>Sessions</Text>
            </Grid.Col>
          </Grid>
        </Stack>
        <Stack spacing={0}>
          {thisInfo.regions.map(function (item, idx) {
            if (!item.capacity && !item.sessions){ return; }
            return (
              <Grid columns={9} key={thisInfo.address + idx}>
                <Grid.Col span={3}>
                  <RegionToText
                    orchestratorName={item.orchestratorName}
                    orchestratorRegion={item.orchestratorRegion}
                  />
                </Grid.Col>
                <Grid.Col span={3}>
                  <Text>{item.capacity}</Text>
                </Grid.Col>
                <Grid.Col span={3}>
                  <Text>{item.sessions}</Text>
                </Grid.Col>
              </Grid>
            );
          })}
        </Stack>
      </Stack>
      <Center>
        <Stack spacing={12}>
          <Text size="xl" fw={700}>
            Latest Payouts
          </Text>
          {!thisPayments.length ? <Text>No payouts yet</Text> : null}
          {thisPayments.slice(0).reverse().map(function (item, idx) {
            if (Math.floor(idx / itemsPerPage) + 1 == activePage) {
              return <PaymentBox key={"payment-" + idx} paymentInfo={item} />;
            }
          })}
          <Pagination
            page={activePage}
            onChange={setPage}
            total={maxPages}
            position="center"
          />
        </Stack>
      </Center>
    </Stack>
  );
}
